import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import endPoint from "../EndPoint/endpoint";

export const AddToCart = createAsyncThunk(
  "product/AddToCart",
  async (cartData, thunkAPI) => {
    try {
      let storedUuid = localStorage.getItem("uuid");
      const Token = localStorage.getItem("loginData");
      const response = await axios.post(
        endPoint.ADDTOCART,
        {
          productId: cartData?.productId,
          quantity: cartData?.quantity,
          sessionId: storedUuid ? storedUuid : "",
        },
        {
          headers: {
            Authorization: Token ? `Bearer ${Token}` : "",
          },
        }
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const AddToCartSlice = createSlice({
  name: "AllData",
  initialState: {
    AllData: [],
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(AddToCart.fulfilled, (state, action) => {
        state.AllData = action.payload;
      })
      .addCase(AddToCart.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export default AddToCartSlice.reducer;
